import type { State } from '../../typings'
import type { State as ActivityState } from '../../../../state'
import type { ActivityType } from '../../../typings'

export const fetchAllActivityTypesProducer = (
  state: State | ActivityState,
  payload: ActivityType[],
) => ({ ...state, activityTypes: payload })
